<button
  class="p-2 hover:bg-light-grey transition-all duration-100 rounded"
  (click)="close.emit()"
>
  <app-icon
    [width]="20"
    [height]="20"
    path="./assets/icons/x.svg"
  />
</button>
